import { PAGE_LEVEL } from '@/constants';
export default {
  meta: { localeModules: ['translate', 'aiChat', 'report'] },
  // 翻译
  path: '/translation',
  redirect: '/translation/index',
  children: [
    {
      path: 'index',
      name: 'translationIndex',
      component: () => import(/* webpackChunkName: 'voice-index' */ '@/pages/translation/index'),
      meta: {
        name: 'routers.translation_translation',
        pageLevel: PAGE_LEVEL.FIRST
      }
    },
    {
      path: 'detail',
      name: 'translationDetail',
      component: () => import(/* webpackChunkName: 'voice-detail' */ '@/pages/translation/detail'),
      meta: {
        name: 'routers.translation_translation_detail',
        pageLevel: PAGE_LEVEL.FIRST,
        keepAlive: true,
        componentName: 'TranslationDetail'
      }
    }
  ]
};
